export const NOTIFICATION_ERROR_MESSAGES = {
  TRY_AGAIN_AFTER_SOMETIME: 'Please try again after some time...',
  PLEASE_RELOAD_TRY_AGAIN: 'Please reload the page and try again...',
  ERROR_ENCOUNTERED_WHILE_FETCHING_POLICY_DETAILS:
    'Encountered an error while fetching policy details.',
}

export const INUSURANCE_STEP_DETAILS_2 =
  'Your policy quick snapshot is here. Insurance Provider, Start & End date, Sum Insured, Claims.'

export const INUSURANCE_STEP_DETAILS_3 = 'View key benefits of our policy.'

export const INUSURANCE_STEP_DETAILS_5 =
  'Download your policy documents by clicking on the download icon.'

export const STEP_IDS = {
  STEP_1: 'RiskScoreTourStep1',
  STEP_2: 'RiskScoreTourStep2',
  STEP_3: 'RiskScoreTourStep3',
}

export const POPUP_STEPS = {
  STEP_1: 'step1',
}

export const INSURANCE_STEPS = {
  STEP_2: 'InsuranceDetailsStepTwo',
  STEP_3: 'InsuranceDetailsStepThree',
  STEP_5: 'InsuranceDetailsStepFive',
}
